import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { ContentBoxInterface } from 'common/types/entities/ContentBoxInterface'
import { MasterBlockId } from 'src/shared/types/base-entity-interface'
import { BorderStyleEnum } from 'common/types/styleTypes'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export const createContentBox = (
  parentId: string,
  masterBlockId?: MasterBlockId,
): ContentBoxInterface => {
  return {
    ...generateBaseEntity(EntityTypeEnum.ContentBox, parentId, masterBlockId),
    header: {
      visibility: true,
      color: 'rgba(255, 255, 255, 1)',
      backgroundColor: 'rgba(85, 121, 195, 1)',
      fontSize: 20,
      textAlign: 'left',
    },
    border: {
      width: 1,
      style: BorderStyleEnum.solid,
      color: 'rgba(85, 121, 195, 1)',
    },
    padding: {
      paddingTop: 10,
      paddingRight: 10,
      paddingBottom: 10,
      paddingLeft: 10,
    },
    delay: 0,
    childIds: [],
  }
}
